export default __webpack_public_path__ + "static/ku_wzor_czarna-6aceae1e3abacde5968043b7f19f6356.jpg";